module.exports = __webpack_public_path__ + "img/socupv1red.eb5cb30a.svg";